module.exports = "img/photo29.329f5a.jpg";